<template>
  <div class="c-tabs">
    <div class="c-tabs-item" v-for="item in tabItems"
         track-by="$index"
         :class="item.select ? 'c-tabs-item-select':''"
         @click="itemClick(item)">
      {{item.name}}
    
    </div>
    <!--<div class="c-tabs-item-shadow"></div>-->
  </div>
</template>
<style lang="scss" scoped>
  @import "./index";
</style>
<script>
  export default{
    name: 'c-tab',
    props: {
      tabItems: {
        type: Array,
        required: true,
        default: () => {
          return []
        }
      }
    },
    data () {
      return {}
    },
    components: {},
    created () {},
    mounted () {},
    beforeDestroy () {},
    methods: {
      itemClick (itemObj) {
        this.$emit('itemClick', itemObj)
      }
    },
    computed: {},
    events: {}
  }
</script>



// WEBPACK FOOTER //
// index.vue?8eacd8a4